module.exports = __webpack_public_path__ + "img/move-hero-large.af7aeac3.png";